import PoppinsCondensedFooter from '@/components/condensed_footer/PoppinsCondensedFooter.vue';

export default () => {
  const footerNode = document.getElementById('app');

  if (footerNode) {
    new PoppinsCondensedFooter().$mount('#footer');
  }
};
